module.exports = __webpack_public_path__ + "static/media/minus-circle-32x32.975d5e8b.svg";